import { Col, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { Formik,Form, Field } from "formik";
import { toast } from "react-toastify";
interface StaticModalToggleProp{
  staticModalToggle:()=>void
}

export const StaticForm = ({staticModalToggle}:StaticModalToggleProp) => {
  return (
    <Formik initialValues={{ email: "", password: "" }} onSubmit={() => {toast.success("form submit");}}>
     {()=>(
      <Form className="row g-3">
      <Col md="12">
        <Label>Email</Label>
        <Field className="form-control" name="email" type="email" placeholder="Enter Your Email" />
      </Col>
      <Col md="12">
        <Label className="form-label" htmlFor="inputPassword4">Password</Label>
        <Field className="form-control" name="password" type="password" placeholder="Enter Your Password" />
      </Col>
      <Col xs="12">
        <div className="form-check">
          <Input className="form-check-input" type="checkbox" />
          <Label className="form-check-label" htmlFor="gridCheck">Check me out</Label>
        </div>
      </Col>
      <Col xs="12">
        <Btn color="primary" type="submit" onClick={staticModalToggle}>Sign in</Btn>
      </Col>
    </Form>
     )}
    </Formik>
  );
};
